export default "__VITE_ASSET__DbQJhPWJ__"